import { Outlet, RouteObject } from 'react-router-dom';

import { ProtectedRoute } from 'create/atoms/authorization/ProtectedRoute';

export const inviteRoutes: RouteObject[] = [
  {
    path: 'invites/*',
    element: (
      <ProtectedRoute action="read_track_invites:team">
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { index: true, lazy: () => import('./InvitesList').then(m => ({ Component: m.InvitesList })) },
      { path: 'new', lazy: () => import('./CreateInvite').then(m => ({ Component: m.CreateInvite })) },
      { path: ':inviteID/edit', lazy: () => import('./EditInvite').then(m => ({ Component: m.EditInvite })) },
      {
        path: ':inviteID/duplicate',
        lazy: () => import('./DuplicateInvite').then(m => ({ Component: m.DuplicateInvite })),
      },
      {
        path: ':inviteID/activity-report',
        lazy: () => import('./ActivityReport').then(m => ({ Component: m.ActivityReport })),
      },
      {
        path: ':inviteID/live-event/*',
        children: [
          {
            index: true,
            lazy: () => import('./ClassroomPage').then(({ ClassroomPage }) => ({ Component: ClassroomPage })),
          },
          {
            path: ':userID/activity',
            lazy: () => import('./ActivityPage').then(({ ActivityPage }) => ({ Component: ActivityPage })),
          },
        ],
      },
      { path: ':inviteID', lazy: () => import('./ViewInvite').then(m => ({ Component: m.ViewInvite })) },
    ],
  },
];
